import { Image } from '@acme/assets';

export const NoData = ({ title }: { title: string }) => {
  return (
    <div
      className={
        'flex flex-col items-center justify-center px-0 py-24 bg-white h-full'
      }
    >
      <div className="flex flex-col gap-6 items-center justify-center p-6 w-[448px] ">
        <div className="overflow-hidden relative shrink-0 w-40">
          <Image
            name={'app-monetization'}
            alt={`no currency rates`}
            className="w-full h-full object-contain"
            width="100%"
            height="100%"
          />
        </div>
        <div className="flex flex-col gap-1 items-center relative shrink-0 w-full">
          <div className="flex flex-col gap-0 items-center relative shrink-0 w-full text-base text-center">
            <div className="font-medium text-base leading-normal text-center align-middle text-gray-900 tracking-normal">
              {title}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
